<app-alert-modal [open]="open | async"
  message="File upload progress might be lost on logout. Please confirm logout action." acceptText="LOGOUT"
  (openChange)="onAlertChange($event)">

</app-alert-modal>